module.exports = __webpack_public_path__ + "static/media/nima_play_jhali_head01.a0ba926b.gif";